import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Translation } from 'react-i18next';

import { connect } from 'react-redux';

import { fetchMe } from 'redux/users/actions';
import { clearPatchUser } from 'redux/settings/actions';

import EarnSwitcher from 'components/dashboard/earn-content/EarnSwitcher';
import AdsenseMainContent from 'components/dashboard/earn-content/adsense/AdsenseMainContent';
import EarningsSection from 'components/dashboard/earn-content/EarningsSection';
import AnalyticsPlaceholder from 'components/dashboard/analytics-content/AnalyticsPlaceholder';
import EarnStatusMessages from 'components/dashboard/earn-content/EarnStatusMessages';

import './EarnPageContent.css';

class EarnPageContent extends Component {
  static propTypes = {
    fetchMe: PropTypes.func.isRequired,
    clearPatchUser: PropTypes.func.isRequired,
    patchUserSuccess: PropTypes.object,
    patchUserError: PropTypes.object,
    me: PropTypes.object,
  };

  static defaultProps = {
    patchUserSuccess: null,
    patchUserError: null,
    me: null,
  };

  componentDidUpdate(prevProps) {
    if (
      !prevProps.patchUserSuccess &&
      prevProps.patchUserSuccess !== this.props.patchUserSuccess
    ) {
      this.props.fetchMe();
      setTimeout(() => {
        this.props.clearPatchUser();
      }, 500);
    }
  }

  render() {
    const { me } = this.props;

    if (!me) return null;

    const adsenseNotConnected = me.afp_enable && !me.adsense_publisher_id;

    return (
      <Translation>
        {(t) => (
          <div className="earn-page-content__component">
            {/* Enable/disable switcher */}
            {!me.advertise_blocked &&
              !me.advertise_status.includes('declined') &&
              <EarnSwitcher />
            }

            {/* Adsense Main Content */}
            {!me.advertise_blocked &&
              me.advertise_enable &&
              me.afp_enable &&
              <AdsenseMainContent me={me} />
            }

            {/* Earn status message */}
            <EarnStatusMessages />

            {/* Earn graph */}
            {!me.advertise_blocked &&
              me.advertise_enable &&
              !adsenseNotConnected &&
              <EarningsSection userId={(me && me.id) || null} />
            }

            {/* Advertise blocked */}
            {me.advertise_blocked &&
              <AnalyticsPlaceholder
                className="earn-page-content-blocked-content"
                text={
                  <>
                    <h3>
                      {t("Your access to “Earn” feature was temporarily put on hold. " +
                        "Typically it happens when there is a complaint related to your content; " +
                        "content might be offensive or illegal; you breached one or several " +
                        "terms of services.")} {t("Please reach out to")} <a href="mailto:team@heylink.me">team@heylink.me</a> {t("to ask about your case.")}
                    </h3>
                  </>
                }
              />
            }

          </div>
        )}
      </Translation>
    );
  }
}

const mapStateToProps = state => (
  {
    me: state.usersReducer.me,
    patchUserSuccess: state.settingsReducer.patchUserSuccess,
    patchUserError: state.settingsReducer.patchUserError,
  }
);

export default connect(
  mapStateToProps,
  {
    fetchMe,
    clearPatchUser,
  },
)(EarnPageContent);
